export const getPdfOptions = (fileName: string) => ({
  margin: [0, 0, 0, 0],
  filename: fileName,
  html2canvas: { dpi: 75, scale: 2, letterRendering: true },
  pagebreak: { mode: ["avoid-all", "css", "legacy"] },
  jsPDF: { orientation: "portrait", unit: "in", format: "a4", compressPDF: true },
  image: { type: "jpeg", quality: 1 },
});
